import { Component, OnInit, OnDestroy } from '@angular/core';
import { Util } from '../../../shared-service/util.service';
import { BaseService } from '../../../shared-service/base.service';
import { SharingPanelService } from '../../../shared-service/sharing-panel-service';
import { OverviewService } from '../overview.service';
import { SharingPanelComponent } from '../../../shared-components/sharing-panel/sharing-panel.component';
import { SettingPanelComponent } from '../settings-panel/settings-panel.component';

declare var $: any;

@Component({
	selector: 'timeline',
	templateUrl: './timeline.component.html',
	styleUrls: ['./timeline.component.css']
})
export class TimelineComponent implements OnInit, OnDestroy {

	uLoad: any;
	FileData: object|any = {};
	TimeLineLists: Array<any> = [];
	AchievmentLists: Array<any> = [];
	ParamsTimeLine: object|any = {};
	loader: boolean = true;
	NoTimeLine: boolean = false;
	NoAcheivement: boolean = false;

	public loadMoreButton: boolean = false;
	public loadingMoreData: boolean = false;

	TimeLineInline: object = { ShareFileType: 'I' }
	subs: any;
	showAchievement: boolean = false;

	params: object|any = {};

	constructor(private util: Util, private os: OverviewService, public bs: BaseService, private sps: SharingPanelService) { }

	ngOnInit() {		
		this.params = {
			'UserID': this.bs.getUserAttr('UserId'),
			'CorporateID': this.bs.getUserAttr('CorporateId'),
			'PageNumber': 1,
			'PageSize': this.bs.config['pageSize']
		};
		// this.getFileControlDetail();
		this.getTimeLineTiles(false);
		this.subs = this.sps.sharedSuccess.subscribe((val) => {
			console.log('TimelineComponent', val);
			if (val) {
				this.params = {
					'UserID': this.bs.getUserAttr('UserId'),
					'CorporateID': this.bs.getUserAttr('CorporateId'),
					'PageNumber': 1,
					'PageSize': this.bs.config['pageSize']
				};
				this.getTimeLineTiles(false);
			}
		})
	}

	ngOnDestroy() {
		console.log('TimelineComponent', this.subs);
		this.subs.unsubscribe();
	}

	getTimeLineTiles(add: boolean) {
		this.os.getUserTimeLineTiles(this.params, '****').then((data:any) => {
			if (add) {
				this.TimeLineLists = this.TimeLineLists.concat(data['TimeLineLists']);
			} else {
				this.TimeLineLists = data['TimeLineLists'];
			}
			this.AchievmentLists = data['AchievmentLists'];
			this.loader = false;
			this.setLoadMoreButton(data);
			if (this.TimeLineLists.length== 0) {
				this.NoTimeLine = true;
			}
			if (this.AchievmentLists.length == 0) {
				this.NoAcheivement = true;
			}
		}, (data) => {
			this.loader = false;
			if (this.loadMoreButton) {
				this.loadingMoreData = false;
			}
		});



	}

	setLoadMoreButton(data:any) {
		if ((data['PageNumber'] * data['PageSize']) >= data['TotalRecords']) {
			this.loadMoreButton = false;
		} else {
			this.loadMoreButton = true;
			this.loadingMoreData = false;
		}
	}

	loadMoreData() {
		this.loadingMoreData = true;
		this.params['PageNumber'] = this.params['PageNumber'] + 1;
		this.getTimeLineTiles(true);
	}

	//RemoveTile Section
	RemoveTile(item: Object[]|any) {
		let confirmMsg = this.bs.getResource('rbkey_CnfrmDltnHdPstMSG');
		let r = confirm(confirmMsg);
		if (r == true) {
			this.ParamsTimeLine['TileId'] = item['TileId'];
			this.ParamsTimeLine['ShareId'] = item['ShareId'];
			this.ParamsTimeLine['UserID'] = this.bs.getUserAttr('UserId');
			this.os.RemoveTimeLineTile(this.ParamsTimeLine, "****").then((data) => {
				this.params['PageNumber'] = 1;
				this.getTimeLineTiles(false);
			}, (data) => {
			});

		}
		return false;
	}

	//BlockUserTimeLineTiles Section
	BlockUserTimeLineTiles(item: Object[]|any) {
		let confirmMsg = this.bs.getResource('rbkey_CnfrmDltnHdPstFrmThisPesnMSG');
		confirmMsg = confirmMsg.replace('~~~***~~~1', item['OriginatorName']);
		let r = confirm(confirmMsg);
		if (r == true) {
			this.ParamsTimeLine['Originator'] = item['Originator'];
			this.ParamsTimeLine['SharedBy'] = item['SharedBy'];
			this.ParamsTimeLine['UserID'] = this.bs.getUserAttr('UserId');
			this.os.BlockUserTimeLineTiles(this.ParamsTimeLine, "****").then((data) => {
				this.params['PageNumber'] = 1;
				this.getTimeLineTiles(false);
			}, (data) => {
			});
		}
		return false;
	}
	//Like Section
	LikeTimeLineTile(item: Object[]|any, Index: number) {

		if (item["SharedBy"] != this.bs.getUserAttr('UserId')) {
			this.ParamsTimeLine['TileId'] = item['TileId'];
			this.ParamsTimeLine['ShareId'] = item['ShareId'];
			this.ParamsTimeLine['UserID'] = this.bs.getUserAttr('UserId');
			this.os.LikeUpdateOverTimeLine(this.ParamsTimeLine, "****").then((data:any) => {
				setTimeout(() => {
					if (data['IsLiked']) {
						$('#TimeLine' + Index).addClass('fa-thumbs-up-blue');
					}
					else {
						$('#TimeLine' + Index).removeClass('fa-thumbs-up-blue');
					}
					$('#TimeLineLike' + Index)[0].textContent = data["LikeCount"];

				}, 300);
			},
				(data) => {
				});

			return false;
		}
	}

	//Reported Abuse Section
	ReportAbuseTimeLine(item: Object[]|any, Index: number) {
		if (item['IsReportedAbuse']) {
			alert(this.bs.getResource('rbkey_RprtAbsMSG'));
			return false;
		}
		else {
			var message = prompt(this.bs.getResource('rbkey_RprtAbsPrmptMSG'));
			if (message != null) {
				var msgLenght = message.length;
				if (msgLenght == 0) {
					alert(this.bs.getResource('rbkey_RprtAbsVldtMSG'));
					return false;
				}
				if (msgLenght > 250) {
					alert(this.bs.getResource('rbkey_RprtAbsLnthMSG'));
					return false;
				}
				else {
					this.ParamsTimeLine['ItemId'] = 0;
					this.ParamsTimeLine['TileId'] = item['TileId'];
					this.ParamsTimeLine['ItemType'] = 'TL';
					this.ParamsTimeLine['UserID'] = this.bs.getUserAttr('UserId');
					this.ParamsTimeLine['PostedContentUserId'] = item['SharedBy'];;
					this.ParamsTimeLine['ReportAbuseComment'] = message;
					this.os.SetTimeLineReportedAbuseComment(this.ParamsTimeLine, "****").then((data:any) => {
						setTimeout(() => {
							this.TimeLineLists[Index]["IsReportedAbuse"] = true;
							$('#TimeLineReportAbuse' + item["TileId"]).addClass('fa-flag-red');
						}, 200);
					},
						(data) => {
						});
					return false;
				}
			}
		}
		return false;
	}
	DeleteTimeLine(TileId: number) {
		let confirmMsg = this.bs.getResource('rbkey_CnfrmDltnPstMSG');
		let r = confirm(confirmMsg);
		if (r == true) {
			this.loader = true;
			const params: object =
			{
				'UserID': this.bs.getUserAttr('UserId'),
				'CorporateID': this.bs.getUserAttr('CorporateId'),
				'PageNumber': 1,
				'TileId': TileId
			};
			this.os.DeleteTimeLineTile(params, "****").then((data) => {
				this.params['PageNumber'] = 1;
				this.getTimeLineTiles(false);
				this.loader = false;
			}, (data) => {
				this.loader = false;
			});
		}
		return false;
	}


	EditTimeLine(item: Object[], Index: number) {
		return false;
	}

	getFileControlDetail() {
		const fileParam = {
			'AllowedFileTypes': 'DOCUMENTS',
			'FileLabel': 'Answer File Upload'
		};
		this.os.getFileControlDetailsServer(fileParam, null).then((data:any) => {
			this.FileData['AllowedDisplayFileTypes'] = data['AllowedDisplayFileTypes'];
			this.FileData['AllowFileSize'] = data['AllowFileSize'];
		}, (data) => {
			this.bs.log('info', 'Error in getting list');
		});
	}
	//To increase or decrease comment count after adding or deletion of comments
	onCount(count: any): void {
		var action = count.split("~");
		if (action[1] == "A") {
			$('#' + action[0]).html(parseInt($('#' + action[0]).html()) + 1);
		}
		else if (action[1] == "D") {
			$('#' + action[0]).html(parseInt($('#' + action[0]).html()) - 1);
		}
	}
	uploadItem(evt: any, type: string) {
		console.log(type, evt);
		this.uLoad = this.util.uploadFile(evt.target.files[0], this.FileData['AllowedDisplayFileTypes'], this.bs.uploadControls['generic']).subscribe((progress:any) => {
			if (typeof progress == 'number') {
				console.log(progress);
			} else if (typeof progress == 'object') {
				const jObj = progress;
				if (jObj['IsValidFileType'] == 'False') {
					//this.util.toaster(this.bs.getResource('rbkey_InvldFlTyp'));
					return false;
				}
				if (jObj['IsVirusInfectedFile'] == 'True') {
					//this.util.toaster(this.bs.getResource('rbkey_InfctdFlTyp'));
					return false;
				}
				if (jObj['IsValidFileName'] == 'False') {
					//this.util.toaster(this.bs.getResource('rbkey_InvldFlNm'));
					return false;
				}
				console.log(jObj);
				evt.target.files[0]['SaveFilePath'] = jObj['SaveFilePath'];

				/*Do according to functionality*/
				/*if (this.FileArray.length == 0) {
					this.FileArray = this.FileArray.concat(evt.target.files[0]);
				}*/
				//this.util.toaster(this.bs.getResource('rbkey_UpldScsfll'));
			}
		}, (err:any) => {
			//$( "#choose-slide" ).panel( "close" );
			//this.util.toaster(this.bs.getResource('rbkey_ErrUpldngFl'));
			setTimeout(() => { this.uLoad.unsubscribe(); }, 50);
		}, () => {
			console.log('complete');
			setTimeout(() => { this.uLoad.unsubscribe(); }, 50);
		});
	}

	openSharingPanel(item: object) {
		this.sps.updateComponentObj(SharingPanelComponent, item);
		this.sps.updateActiveWall(true);
	}

	OpenAttachment(AttachmentPath: string) {
		window.open(AttachmentPath)
		return false;
	}

	openPanelSetting() {
		this.sps.updateComponentObj(SettingPanelComponent, { setting: true });
		this.sps.updateActiveWall(true);
	}

	toggleAchievement() {
		if (this.showAchievement) {
			this.showAchievement = false;
			$('#achieve').removeClass('active');
			$('#buzz').addClass('active');
		} else {
			this.showAchievement = true;
			$('#buzz').removeClass('active');
			$('#achieve').addClass('active');
		}
	}
}
